export default __webpack_public_path__ + "static/media/898.fd9c877c.png";